import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getResponsiveOptions = gaugeWidth => {
  let dataValueTypography = 'heading-600';
  let dataValueLabelTypography = 'body-200';
  let compareValueTypography = 'detail-200';
  let verticalOffsetRate = 1;
  if (gaugeWidth) {
    if (gaugeWidth >= 700) {
      dataValueTypography = 'display-400';
      dataValueLabelTypography = 'heading-100';
      compareValueTypography = 'body-100';
    } else if (gaugeWidth >= 600) {
      dataValueTypography = 'display-300';
      dataValueLabelTypography = 'heading-100';
      compareValueTypography = 'body-100';
    } else if (gaugeWidth >= 500) {
      dataValueTypography = 'display-200';
      dataValueLabelTypography = 'heading-100';
      compareValueTypography = 'body-100';
    } else if (gaugeWidth >= 400) {
      dataValueTypography = 'heading-1000';
      dataValueLabelTypography = 'heading-100';
      compareValueTypography = 'body-100';
    } else if (gaugeWidth >= 300) {
      dataValueTypography = 'heading-900';
      dataValueLabelTypography = 'heading-100';
      compareValueTypography = 'body-100';
    } else if (gaugeWidth >= 250) {
      dataValueTypography = 'heading-800';
      dataValueLabelTypography = 'heading-100';
      compareValueTypography = 'body-100';
    } else if (gaugeWidth >= 200) {
      dataValueTypography = 'heading-700';
      dataValueLabelTypography = 'heading-100';
      compareValueTypography = 'body-100';
      verticalOffsetRate = 1.25;
    } else if (gaugeWidth >= 175) {
      dataValueTypography = 'heading-600';
      dataValueLabelTypography = 'heading-100';
      compareValueTypography = 'body-100';
      verticalOffsetRate = 1.25;
    } else if (gaugeWidth >= 150) {
      dataValueTypography = 'heading-400';
      dataValueLabelTypography = 'heading-50';
      compareValueTypography = 'detail-100';
      verticalOffsetRate = 1.5;
    } else if (gaugeWidth >= 100) {
      dataValueTypography = 'heading-200';
      dataValueLabelTypography = 'heading-50';
      compareValueTypography = 'detail-100';
      verticalOffsetRate = 1.75;
    } else if (gaugeWidth >= 50) {
      dataValueTypography = 'heading-50';
      dataValueLabelTypography = 'heading-25';
      compareValueTypography = 'detail-100';
      verticalOffsetRate = 2;
    } else {
      dataValueTypography = 'heading-25';
      dataValueLabelTypography = 'heading-25';
      compareValueTypography = 'detail-100';
      verticalOffsetRate = 2.25;
    }
  }
  return {
    dataValue: {
      typography: dataValueTypography,
      verticalOffsetRate
    },
    dataValueLabel: {
      typography: dataValueLabelTypography,
      verticalOffsetRate
    },
    compareValue: {
      typography: compareValueTypography,
      verticalOffsetRate
    }
  };
};

/* @bend-expect no-styled-foundations-components */
const GaugeDataLabelContainer = styled(TFlex).withConfig({
  displayName: "GaugeDataLabel__GaugeDataLabelContainer",
  componentId: "tlvawu-0"
})(["", ""], ({
  width,
  responsiveOptions,
  theme
}) => {
  const dataValueTextOffset = theme.typography[responsiveOptions.dataValue.typography].lineHeight;
  const verticalOffset = `calc(-${dataValueTextOffset} * ${responsiveOptions.dataValue.verticalOffsetRate})`;
  return `
      transform: translateY(${verticalOffset});
      ${width ? `width: ${width}px` : {}}
    `;
});
const DataValueContainer = styled.div.withConfig({
  displayName: "GaugeDataLabel__DataValueContainer",
  componentId: "tlvawu-1"
})(["", ""], ({
  width
}) => width && `width: ${width}px;`);
export const GaugeDataLabel = ({
  dataValue,
  dataValueLabel,
  compareValue,
  chartWidth,
  gaugeWidth
}) => {
  const responsiveOptions = getResponsiveOptions(gaugeWidth);
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsxs(GaugeDataLabelContainer, {
      "data-test-id": "gauge-data-label",
      flexDirection: "column",
      alignItems: "center",
      width: chartWidth,
      responsiveOptions: responsiveOptions,
      children: [/*#__PURE__*/_jsx(DataValueContainer, {
        width: gaugeWidth,
        children: /*#__PURE__*/_jsx(Text, {
          typography: responsiveOptions.dataValue.typography,
          truncate: true,
          textAlign: "center",
          children: dataValue
        })
      }), /*#__PURE__*/_jsx(DataValueContainer, {
        width: chartWidth,
        children: /*#__PURE__*/_jsx(Text, {
          typography: responsiveOptions.dataValueLabel.typography,
          truncate: {
            lineClamp: 2
          },
          textAlign: "center",
          textWrap: "wrap",
          wordBreak: "break-all" // to handle handle translations with very long words
          ,
          children: dataValueLabel
        })
      }), compareValue ?
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(DataValueContainer, {
        width: chartWidth,
        children: /*#__PURE__*/_jsx(Text, {
          typography: responsiveOptions.compareValue.typography,
          truncate: {
            lineClamp: 2
          },
          textAlign: "center",
          textWrap: "wrap",
          wordBreak: "break-all" // to handle handle translations with very long words
          ,
          children: I18n.text('reporting-visualizations.gauge.comparison-label', {
            value: compareValue
          })
        })
      }) : null]
    })
  );
};